"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContext = exports.User = exports.TokenState = void 0;
var react_1 = __importDefault(require("react"));
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var inputSource_1 = __importDefault(require("@incentivegames/ig-types/lib/constants/communication/inputSource"));
var os_1 = __importDefault(require("@incentivegames/ig-types/lib/constants/os"));
var postMessageActions_1 = __importDefault(require("@incentivegames/ig-types/lib/constants/communication/postMessageActions"));
var communicationUtilities_1 = require("../utilities/communicationUtilities");
var cookies = new universal_cookie_1.default();
var TokenState;
(function (TokenState) {
    TokenState[TokenState["NoTokenReceived"] = 0] = "NoTokenReceived";
    TokenState[TokenState["ValidToken"] = 1] = "ValidToken";
    TokenState[TokenState["InvalidToken"] = 2] = "InvalidToken";
})(TokenState = exports.TokenState || (exports.TokenState = {}));
var User = /** @class */ (function () {
    function User(params, config, languageManager) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        this.isAuthenticated = function () {
            return !!_this._token;
        };
        this.isLangSet = function () {
            return _this._lang !== '';
        };
        this.setpromotion = function (promotion) {
            _this._promotion = promotion;
        };
        this.setToken = function (token) {
            _this._token = token;
        };
        this.setTokenState = function (token) {
            if (token === undefined) {
                _this._tokenState = TokenState.NoTokenReceived;
            }
            else {
                if (token) {
                    _this._tokenState = TokenState.ValidToken;
                }
                else {
                    _this._tokenState = TokenState.InvalidToken;
                }
            }
        };
        this.setLang = function (lang) {
            _this._lang = lang;
        };
        this.setCurrency = function (currency) {
            _this._currencyCode = currency;
        };
        this.setCustomerId = function (customerId) {
            _this._customerId = customerId;
        };
        this.setCountryCode = function (countryCode) {
            _this._countryCode = countryCode;
        };
        this.setRegionCode = function (regionCode) {
            _this._regionCode = regionCode;
        };
        this.setTimeZone = function (timeZone) {
            _this._timeZone = timeZone;
        };
        this.updateToken = function (token) {
            _this.setTokenState(token);
            _this.setToken(token);
        };
        this.updateLanguage = function (lang) {
            var _a;
            if (lang !== '' && lang !== _this._lang && _this._supportedLanguages.includes(lang.toLocaleLowerCase())) {
                _this.setLang(lang);
                (_a = _this._languageManager) === null || _a === void 0 ? void 0 : _a.changeLanguage(lang.toLocaleLowerCase());
            }
        };
        this.updateCurrency = function (currency) {
            var _a;
            if (currency !== '' && ((_a = _this._currencyCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== currency.toUpperCase() && _this._supportedCurrencies.includes(currency.toUpperCase())) {
                _this.setCurrency(currency.toUpperCase());
            }
        };
        this.updateCustomerId = function (customerId) {
            _this.setCustomerId(customerId);
        };
        this.updateCountryCode = function (countryCode) {
            _this.setCountryCode(countryCode);
        };
        this.updateRegionCode = function (regionCode) {
            _this.setRegionCode(regionCode);
        };
        this.updateTimeZone = function (timeZone) {
            _this.setTimeZone(timeZone);
        };
        this.getTokenFromUrl = function () {
            var _a;
            if (_this._tokenFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._tokenCookieName)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.getLangFromUrl = function () {
            var _a;
            if (_this._languageFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._languageCodeIdentifier)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.getCurrencyFromUrl = function () {
            var _a;
            if (_this._currencyFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._currencyCodeIdentifier)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.getCustomerIdFromUrl = function () {
            var _a;
            if (_this._tokenFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._customerIdIdentifier)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.getCountryCodeFromUrl = function () {
            var _a;
            if (_this._countryCodeFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._countryCodeIdentifier)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.getRegionCodeFromUrl = function () {
            var _a;
            if (_this._regionCodeFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._regionCodeIdentifier)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.getTimeZoneFromUrl = function () {
            var _a;
            if (_this._timeZoneFromParentType === inputSource_1.default.URL) {
                return (_a = new URLSearchParams(window.location.search).get(_this._timeZoneIdentifier)) !== null && _a !== void 0 ? _a : '';
            }
        };
        this.addConfigHandlers = function (playerDataCallback, languageCallback, currencyCallback, customerIdCallback, countryCodeCallback, regionCodeCallback, timeZoneCallback, 
        /**
         * Called when the window receives a postMessage where the
         * event message data has a property called `action` with the value `share`.
         */
        shareCallback) {
            _this.addPostMessageConfigHandlers(playerDataCallback, languageCallback, currencyCallback, customerIdCallback, countryCodeCallback, shareCallback);
            _this.addUrlConfigHandlers(playerDataCallback, languageCallback, currencyCallback, customerIdCallback, countryCodeCallback, regionCodeCallback, timeZoneCallback);
            _this.addCookieConfigHandlers(playerDataCallback, customerIdCallback);
            if (_this._tokenFromParentType === inputSource_1.default.POSTMESSAGE && !_this.isAuthenticated()) {
                communicationUtilities_1.communicationUtilities.sendPostMessage.getToken();
                communicationUtilities_1.communicationUtilities.sendPostMessage.getPlayerData();
            }
        };
        this.addCookieConfigHandlers = function (playerDataCallback, customerIdCallback) {
            var _a, _b;
            if (_this._tokenFromParentType === inputSource_1.default.COOKIES) {
                playerDataCallback((_a = cookies.get(_this._tokenCookieName)) !== null && _a !== void 0 ? _a : '');
                if (customerIdCallback) {
                    customerIdCallback((_b = cookies.get(_this._customerIdIdentifier)) !== null && _b !== void 0 ? _b : '');
                }
            }
        };
        this.addUrlConfigHandlers = function (playerDataCallback, languageCallback, currencyCallback, customerIdCallback, countryCodeCallback, regionCodeCallback, timeZoneCallback) {
            var tokenFromUrl = _this.getTokenFromUrl();
            if (tokenFromUrl)
                playerDataCallback(tokenFromUrl);
            var languageFromUrl = _this.getLangFromUrl();
            if (languageFromUrl)
                languageCallback(languageFromUrl);
            var currencyFromUrl = _this.getCurrencyFromUrl();
            if (currencyFromUrl)
                currencyCallback(currencyFromUrl);
            var customerIdFromUrl = _this.getCustomerIdFromUrl();
            if (customerIdFromUrl && customerIdCallback)
                customerIdCallback(customerIdFromUrl);
            var countryCodeFromUrl = _this.getCountryCodeFromUrl();
            if (countryCodeFromUrl && countryCodeCallback)
                countryCodeCallback(countryCodeFromUrl);
            var regionCodeFromUrl = _this.getRegionCodeFromUrl();
            if (regionCodeFromUrl && regionCodeCallback)
                regionCodeCallback(regionCodeFromUrl);
            var timeZoneFromUrl = _this.getTimeZoneFromUrl();
            if (timeZoneFromUrl && timeZoneCallback)
                timeZoneCallback(timeZoneFromUrl);
        };
        this.addPostMessageConfigHandlers = function (playerDataCallback, languageCallback, currencyCallback, customerIdCallback, countryCodeCallback, shareCallback) {
            window.removeEventListener('message', _this._handlePostMessage, false);
            _this._handlePostMessage = function (event) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                var isPhone = communicationUtilities_1.communicationUtilities.getOs() === os_1.default.ANDROID || communicationUtilities_1.communicationUtilities.getOs() === os_1.default.IOS;
                if (isPhone || (document.referrer && document.referrer !== '')) {
                    if (isPhone || event.origin === new URL(document.referrer).origin) {
                        switch (event.data.action) {
                            case postMessageActions_1.default.PLAYER_DATA:
                            case postMessageActions_1.default.GET_TOKEN:
                                if (_this._tokenFromParentType === inputSource_1.default.POSTMESSAGE && ((_b = (_a = event.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.token)) {
                                    playerDataCallback(event.data.payload.token, event.data.payload.promotion);
                                    // Currently we don't receive the customerId from any customers via post message (and we probably never will, so it doesn't merit it's own message) but if we do then we just need a customerId property in the payload in the GET_TOKEN message
                                    if (customerIdCallback) {
                                        customerIdCallback((_e = (_d = (_c = event.data) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.customerId) !== null && _e !== void 0 ? _e : '');
                                    }
                                }
                                else {
                                    playerDataCallback('');
                                }
                                break;
                            case postMessageActions_1.default.LOGIN:
                                break;
                            case postMessageActions_1.default.UPDATE_LANGUAGE:
                                if (_this._languageFromParentType === inputSource_1.default.POSTMESSAGE && ((_g = (_f = event.data) === null || _f === void 0 ? void 0 : _f.payload) === null || _g === void 0 ? void 0 : _g.language)) {
                                    languageCallback(event.data.payload.language);
                                }
                                break;
                            case postMessageActions_1.default.LOGOUT:
                                playerDataCallback('');
                                break;
                            case postMessageActions_1.default.IS_AUTHENTICATED:
                                break;
                            case postMessageActions_1.default.RESIZE:
                                (_h = document.getElementById('root')) === null || _h === void 0 ? void 0 : _h.setAttribute('style', "min-height:" + event.data.payload.scrollHeight + "px");
                                break;
                            case postMessageActions_1.default.UPDATE_CURRENCY:
                                if (_this._currencyFromParentType === inputSource_1.default.POSTMESSAGE && ((_k = (_j = event.data) === null || _j === void 0 ? void 0 : _j.payload) === null || _k === void 0 ? void 0 : _k.currency)) {
                                    currencyCallback(event.data.payload.currency);
                                }
                                break;
                            case postMessageActions_1.default.UPDATE_COUNTRY_CODE:
                                if (countryCodeCallback && _this._countryCodeFromParentType === inputSource_1.default.POSTMESSAGE && ((_m = (_l = event.data) === null || _l === void 0 ? void 0 : _l.payload) === null || _m === void 0 ? void 0 : _m.countryCode)) {
                                    countryCodeCallback(event.data.payload.countryCode);
                                }
                                break;
                            case postMessageActions_1.default.GET_CONFIG:
                                communicationUtilities_1.communicationUtilities.sendPostMessage.getConfig(_this._tokenFromParentType, _this._tokenCookieName, _this._currencyFromParentType, _this._languageFromParentType, _this._supportedCurrencies, _this._supportedLanguages, _this._defaultCurrency, _this._defaultLanguage, _this._currencyCodeIdentifier, _this._languageCodeIdentifier);
                                break;
                            case postMessageActions_1.default.SHARE:
                                shareCallback && shareCallback();
                                break;
                            default:
                                break;
                        }
                    }
                }
            };
            window.addEventListener('message', _this._handlePostMessage, false);
        };
        this._languageFromParentType = (_a = config.languageFromParentType) !== null && _a !== void 0 ? _a : '';
        this._languageCodeIdentifier = (_b = config.languageCodeIdentifier) !== null && _b !== void 0 ? _b : '';
        this._tokenFromParentType = config.tokenFromParentType;
        this._tokenCookieName = (_c = config.tokenCookieName) !== null && _c !== void 0 ? _c : 'token';
        this._supportedLanguages = (_d = config.supportedLanguages) !== null && _d !== void 0 ? _d : [];
        this._currencyFromParentType = (_e = config.currencyFromParentType) !== null && _e !== void 0 ? _e : '';
        this._currencyCodeIdentifier = (_f = config.currencyCodeIdentifier) !== null && _f !== void 0 ? _f : '';
        this._supportedCurrencies = config.supportedCurrencies
            ? config.supportedCurrencies.map(function (currency) {
                return currency.toUpperCase();
            })
            : [];
        this._defaultCurrency = (_g = config.defaultCurrency) !== null && _g !== void 0 ? _g : '';
        this._defaultLanguage = (_h = config.defaultLanguage) !== null && _h !== void 0 ? _h : '';
        this._languageManager = languageManager;
        this._tokenState = TokenState.NoTokenReceived;
        this._customerId = params.customerId;
        this._customerIdIdentifier = (_j = config.customerIdIdentifier) !== null && _j !== void 0 ? _j : '';
        this._countryCode = params.countryCode;
        this._countryCodeFromParentType = (_k = config.countryCodeFromParentType) !== null && _k !== void 0 ? _k : '';
        this._countryCodeIdentifier = (_l = config.countryCodeIdentifier) !== null && _l !== void 0 ? _l : '';
        this._regionCode = params.regionCode;
        this._regionCodeFromParentType = (_m = config.regionCodeFromParentType) !== null && _m !== void 0 ? _m : '';
        this._regionCodeIdentifier = (_o = config.regionCodeIdentifier) !== null && _o !== void 0 ? _o : '';
        this._timeZone = params.timeZone;
        this._timeZoneFromParentType = (_p = config.timeZoneFromParentType) !== null && _p !== void 0 ? _p : '';
        this._timeZoneIdentifier = (_q = config.timeZoneIdentifier) !== null && _q !== void 0 ? _q : '';
        this._handlePostMessage = function (event) { };
        this.updateToken(params.token);
        this.updateLanguage((_r = params.language) !== null && _r !== void 0 ? _r : '');
        this.updateCurrency((_s = params.currency) !== null && _s !== void 0 ? _s : this._defaultCurrency);
        this.updateCustomerId(params.customerId);
        this.updateCountryCode(params.countryCode);
        this.updateRegionCode(params.regionCode);
        this.updateTimeZone(params.timeZone);
        if (params.promotion) {
            this.setpromotion(params.promotion);
        }
    }
    Object.defineProperty(User.prototype, "promotion", {
        get: function () {
            return this._promotion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "token", {
        get: function () {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "lang", {
        get: function () {
            return this._lang;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "currency", {
        get: function () {
            return this._currencyCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "tokenState", {
        get: function () {
            return this._tokenState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "customerId", {
        get: function () {
            return this._customerId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "countryCode", {
        get: function () {
            return this._countryCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "regionCode", {
        get: function () {
            return this._regionCode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(User.prototype, "timeZone", {
        get: function () {
            return this._timeZone;
        },
        enumerable: false,
        configurable: true
    });
    return User;
}());
exports.User = User;
exports.UserContext = react_1.default.createContext({
    user: new User({}, {
        tokenCookieName: '',
        tokenFromParentType: ''
    }, undefined),
    setToken: function (token) { },
    clearToken: function () { },
    setPlayerData: function (token, promotion) { },
    setLanguage: function (language) { },
    setCurrency: function (currency) { },
    setCustomerId: function (customerId) { },
    setCountryCode: function (countryCode) { },
    setRegionCode: function (regionCode) { },
    setTimeZone: function (timeZone) { }
});
